import React,{useContext,useEffect,useState} from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CartaContext from '../../../context/cartaContext/cartaContext';
import AuthContext from '../../../context/authContext/authContext';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import {
    Container,
    Button,
    Stepper,
    Typography,
    Step,
    StepLabel,
    StepContent,
    Card,
    AccordionSummary,
    Accordion,
    AccordionDetails,
    FormGroup,
    Checkbox,
    CardContent,
    CardActions,
    CircularProgress,
    Snackbar,
    Grow,
    MenuItem,
    Select,
    InputLabel,
    TextField,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    DialogTitle,
    Backdrop,
    TextareaAutosize

} from '@material-ui/core'
//ESTILOS
const useStyles = makeStyles((theme) => ({
    radio : {
        display : 'flex',
        flexDirection : 'column',
        textTransform : 'capitalize',
        padding : '4px 8px 8px',
        width : '100%',
        [theme.breakpoints.up('sm')] : {
            flexDirection : 'row',
            flexWrap : 'wrap'
        }
        
        
    },
    form : {
        textTransform : 'capitalize',
        
    },
    grupoRadio : {
        width : '100%',
        textTransform: 'capitalize',
        display : 'flex'
    },
    stepper :{
        padding : '10px',
        marginTop : '10px',
        marginBottom : '8rem',
        display: 'block'
    },
    botonera : {
        padding : '5px',
        margin: '5px',
        '& button' : {
            margin : '.8rem'
        }
    },
    circular : {
        position : 'relative',
        left: '300%',
        margin : '0 auto',
        [theme.breakpoints.up('sm')] : {
            left : '600%',
        }
    },
    precio : {
        fontWeight : 'bold',
        color: "black"
    },
    card : {
        margin : '1rem'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
    bebida : {
        width : '100%',
        display : 'flex',
        justifyContent : 'space-between',
        alignItems:'center'
    },
    bebida_input : {
        width : '15%',
        marginLeft : '1rem',
    },
    area : {
        marginTop : '1rem',
        '& textarea ':{
            resize: 'none',
            width : '100%'
          }
    },
    cabecera : {
        
        [theme.breakpoints.up('md')]: {
            fontSize : "16px"
        } 
    },
    titulo : {
        textTransform : 'uppercase',
        textAlign : 'center'
    },
    descripcion : {
        marginLeft : '.5rem',
        textTransform : 'capitalize'
    }

}));

//ALERTAS
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

//TITULOS STEPPER
function getSteps() {
    return ['Elegi tu Menu', 'Elegi tu ingrediente', 'Elegi tu Bebida', 'Finaliza tu pedido','Entrega', 'Pagar'];
  }
  


const GenerarPedido = (props) => {
    //PROPS
    const {setactiveComponente} = props;
    //STATE DEL CONTEXT MENU
    const cartaContext = useContext(CartaContext);
    const {
        bebidas,
        ingredientes,
        platos,
        cargando,
        obtenerMenuStock,
 
    
        } = cartaContext
    //STATE DEL CONTEXT AUTH
    const authContext = useContext(AuthContext);
    const {
        cliente,
        autenticado,
        mensaje,
        error,
        carrito,
        pedido,
        total_carrito,
        addCarrito,
        deleteCarrito,
        reiniciarErrorMensaje,
        checkOut,
        confirmarOrden,
        getCarrito,
        cancelarOrden
        } = authContext; 
       
        
    //EFFECT     
    useEffect(() => {
        obtenerMenuStock()
        
       
        if(cliente){
            getCarrito(cliente)
            if(cliente.domicilio)setDomicilio({
                calle : cliente.domicilio
            })
            if(pedido !== null){
                setactiveComponente("cliente")
            }
         
            if(cliente.admin === 'true'){
                props.history.push('/admin')
            }
        }
        
        
       // eslint-disable-next-line   
    }, [autenticado,mensaje]);

    //STATES LOCALES
    const classes = useStyles()
    const [formulario, setFormulario] = useState([
        {
            platos: null,
            ingredientes : [],
            bebidas: []
        }
    ]);
    const [tipoPlato, settipoPlato] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const [formaentrega, setformaentrega] = useState(null);
    const [domicilio , setDomicilio] = useState({
        calle : null,
        barrio : null,
        referencia : null
    });
    const [formaPago, setformaPago] = useState(null);
    const [Open, setOpen] = useState(false);
    const [isloading, setisloading] = useState(false);
    const [especial, setespecial] = useState(false);
    const steps = getSteps();
    
//FILTAR CATEGORIAS DE PLATOS
const filtrar_categorias = [];
//FILTRAR CATEGORIAS DE BEBIDAS
const filtrar_bebidas = []
//OBTENER CATEGORIAS DE PLATOS Y BEBIDAS
if(!cargando && platos){
    platos.forEach(element => {
        filtrar_categorias.push(element.categoria);
        
    });
    var unique = filtrar_categorias.filter((v, i, a) => a.indexOf(v) === i); 
    
}
if(!cargando && bebidas){
    bebidas.forEach(element => {
        filtrar_bebidas.push(element.categoria);
        
    });
    var beb = filtrar_bebidas.filter((v, i, a) => a.indexOf(v) === i); 
    
}
    //VISTAS DEL STEPPER
    function getStepContent(step) {
        switch (step) {
          case 0:
            return  <RadioGroup aria-label="gender" name="gender1" className={classes.grupoRadio}>
                            {unique ? unique.map(categoria => {
                                return  <Accordion key = {categoria}>
                                    <AccordionSummary 
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    <Typography >{categoria}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className ={classes.radio} >
                                        {platos ? platos.map(plato => {
                                            if(plato.categoria === categoria){
                                                return <FormControlLabel 
                                                            key={plato._id} 
                                                            value={plato._id}
                                                            name = {plato.nombre }
                                                            checked = {formulario[0].platos === plato._id ? true : false} 
                                                            control={<Radio />} 
                                                            label={`${plato.nombre}    $ ${plato.precio}`} 
                                                            onChange={platoChange}
                                                            labelPlacement = 'end'
                                                           
                                                            />
                                                        
                                                }
                                            return null 
                                        })
                                        : <div>Cargando..</div>
                                        }
                                        </AccordionDetails>
                                   </Accordion>
                                 
                            }) 
                            :<CircularProgress className={classes.circular} color="secondary" />}
                           
                    </RadioGroup>
          case 1:
            return  (tipoPlato === "milanesa" && !especial) || (tipoPlato === "hamburguesa" && !especial) ? <FormGroup>
                        {ingredientes ? ingredientes.map(ingrediente => {
                             if(tipoPlato === "milanesa" && ingrediente.precio_milanesa ){
                
                                return <FormControlLabel
                                        key={ingrediente._id}
                                        checked = {formulario[0].ingredientes.includes(ingrediente._id)}
                                        control={<Checkbox   value={ingrediente._id} name={ingrediente.nombre} />}
                                        label={tipoPlato === "hamburguesa" ? `${ingrediente.nombre}  $ ${ingrediente.precio_hamburguesa}` 
                                                            : `${ingrediente.nombre}  $ ${ingrediente.precio_milanesa}` }
                                        onChange={ingredienteChange}
                                    />
                                }
                            if(tipoPlato === "hamburguesa" ){
                                return <FormControlLabel
                                key={ingrediente._id}
                                checked = {formulario[0].ingredientes.includes(ingrediente._id)}
                                control={<Checkbox   value={ingrediente._id} name={ingrediente.nombre} />}
                                label={tipoPlato === "hamburguesa" ? `${ingrediente.nombre}  $ ${ingrediente.precio_hamburguesa}` 
                                                    : `${ingrediente.nombre}  $ ${ingrediente.precio_milanesa}` }
                                onChange={ingredienteChange}
                            />
                            }
                            return null    
                                })
                        : <CircularProgress className={classes.circular} color="secondary" />
                        }
        
                    </FormGroup>
                    : <Typography color='error'>Al menu seleccionado no se le pueden colocar ingredientes.</Typography>
          case 2:
            return <FormGroup>
                 {beb ? beb.map(categoria => {
                                return  <Accordion key = {categoria} className = {classes.platos}>
                                    <AccordionSummary 
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                    <Typography  variant="h6">{categoria === "sin_alcohol" ? "Sin Alcohol" : categoria}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className ={classes.radio} >
                                        {bebidas ? bebidas.map(bebida => {
                                        return <div key={bebida._id} className={classes.bebida} >
                                            <Typography>{`${bebida.nombre} $ ${bebida.precio} :`}</Typography>
                                             <div className={classes.bebida_input}>
                                                <TextField 
                                                id={bebida._id}
                                                type="number"
                                                InputLabelProps={{
                                                    shrink: true,
                                                    }}  
                                                onChange={bebidaChange}
                                                name={bebida.nombre } 
                                                inputProps={
                                                    {min : "0"}
                                                    }
                                                />
                                                </div>
                                          
                                                
                                      

                                        
                                    </div>
                        })
                        
                        : <CircularProgress className={classes.circular} color="secondary" />
                        }
                             
                             </AccordionDetails>
                                   </Accordion>
                                 
                            }) 
                            :<div className={classes.circular}><CircularProgress  color="secondary" /></div>}
            
                    </FormGroup>
          case 3 : 
                return <>{carrito ? carrito.map(menu =>{
                    return <Grow key= {menu._id} in={activeStep === 4 ? 'true' : 'false'}
                                   
                                ><Card   className = {classes.card}>
                                <CardContent>
                                  <Typography variant="h5" component="h2" className={classes.titulo} >
                                        {menu.platos.nombre}
                                </Typography>
                                <Typography  color="textSecondary">
                                    Ingredientes:
                                </Typography>
                                {menu.ingredientes.map(ingre =>{
                                    return <Typography key ={ingre._id}variant="body2" component="p" className={classes.descripcion}>
                                            { ingre.nombre }
                                            </Typography>
                                })}
                                <Typography>
                                </Typography>
                                <Typography  color="textSecondary">
                                    Bebidas:
                                </Typography>
                                {menu.bebidas.map(bebida =>{
                                    return <Typography key = {bebida._id} variant="body2" component="p" className={classes.descripcion}>
                                            { bebida.nombre}
                                            </Typography>
                                })}
                                <Typography>
                                    Subtotal : $ {
                                       menu.subtotal
                                        
                                    }
                                </Typography>
                            </CardContent>
                        <CardActions>
                                <Button size="small" onClick= {e=> eliminarMenu(menu._id)}> Eliminar</Button>
                                <Button size="small" variant="contained" onClick= {e=> duplicateMenu(menu)}> Agregar otro</Button>
                    </CardActions>
                  </Card>
                  </Grow>
                })
                : <Typography>No hay elementos en el carrito</Typography>}
              {carrito.length !== 0 ? <Typography className= {classes.precio}>PRECIO FINAL : ${total_carrito}</Typography> : <CircularProgress className={classes.circular} color="secondary" />}
                        </>
          case 4 :
            return <> 
               
                    <RadioGroup row aria-label="forma_entrega" name="forma_entrega" defaultValue="top">
                        <FormControlLabel
                            value="domicilio"
                            control={<Radio color="secondary" />}
                            label="a domicilio"
                            labelPlacement="start"
                            onChange={entregaChange}
                            checked = {formaentrega === "domicilio"}
                        />
                        <FormControlLabel
                            value="take away"
                            control={<Radio color="secondary" />}
                            label="take away!"
                            labelPlacement="start"
                            onChange={entregaChange}
                            checked = {formaentrega === "take away"}
                        />  
                    </RadioGroup>
                    {formaentrega === "domicilio" ? <>
                    <FormControl>
                    <InputLabel id="barrio_select_id">Seleccione su barrio</InputLabel>
                    <Select
                        fullWidth
                        labelId="barrio_selectid"
                        id="barrio_select_id"
                        value = {domicilio.barrio ? domicilio.barrio : ''}
                        onChange={domicilioChange}
                        name = "barrio"
                        >
                      <MenuItem value={"sierra"}>Sierra</MenuItem>
                      <MenuItem value={"san carlos"}>San Carlos</MenuItem>
                      <MenuItem value={"la peregrina"}>La peregrina</MenuItem>
                      <MenuItem value={"colinas verdes"}>Colinas Verdes</MenuItem>
                    </Select>
                    <TextField
                        name="calle"
                        id="calle" 
                        label="Ingrese su domicilio" 
                        defaultValue={domicilio.calle} 
                        fullWidth
                        onChange = {domicilioChange}
                        />
                     <div className = {classes.area}>   
                    <TextareaAutosize 
                        aria-label="minimum height" 
                        rowsMin={3} 
                        placeholder="Escribenos una referencia de tu domicilio para una mejor ubicacion" 
                        onChange = {domicilioChange}
                        id="referencia"
                        name="referencia"
                        />    
                    </div>
                    </FormControl>
                    </>    
                    : null}
                </>
          case 5 : 
            return  <RadioGroup row aria-label="forma_pago" name="forma_Pago" defaultChecked={formaPago}>
            <FormControlLabel
                value="pago_en_destino"
                control={<Radio color="secondary" />}
                label={formaentrega === "domicilio" ? "Pago en destino" : "Pago cuando retiro"}
                labelPlacement="start"
                onChange={pagoChange}
                
            />
            <FormControlLabel
                value="mercado_pago"
                control={<Radio color="secondary" />}
                label="Mercado Pago"
                labelPlacement="start"
                onChange={pagoChange}
                disabled = "true"
              
            />  
        </RadioGroup>

          default:
            return 'Opcion invalida recarga la pagina';
        }
    };

    //FUNCIONES PARA STATE
    const pagoChange = e => {
        setformaPago(e.target.value)
    };
    const domicilioChange = (e) => {
        setDomicilio({
            ...domicilio,
            [e.target.name] : e.target.value
        })
    };  
    const platoChange = (e) => {
      platos.map(plato =>{
          if(plato._id === e.target.value){
            settipoPlato(plato.categoria)
          }
          return null 
    })
      
        const newArray = [];
        const plato = e.target.value;
        newArray.push({platos : plato,
                     ingredientes : [],  
                     bebidas : []
                    });
        setFormulario(newArray);
        if(e.target.value === "5fb807ca72e3cf2886f5d707" || e.target.value === "5fb807e472e3cf2886f5d708" ||  
        e.target.value === "5fb8083172e3cf2886f5d70b" || e.target.value === "5fb8084272e3cf2886f5d70c" ||
        e.target.value === "5fb8086a72e3cf2886f5d70d" || e.target.value === "5fb8088b72e3cf2886f5d70e" ){
         setespecial(true)
        }else{
         setespecial(false)
        }
    };
    const ingredienteChange = (e) => {
        const newArray = [...formulario]
        const ingrediente = newArray[0].ingredientes
        if (e.target.checked) {
            ingrediente.push(e.target.value);
        } else {
                const idx = ingrediente.indexOf(e.target.value);
            if(idx > -1){
                ingrediente.splice(idx, 1);
            }
            
        }
        
        newArray[0].ingredientes = ingrediente
        setFormulario(newArray)
    };
    const bebidaChange = (e) => {
      
        const newArray = [...formulario]
        const bebida = newArray[0].bebidas
        
        if(bebida.find(indx => indx === e.target.id)){
            bebida.splice(0);
            for (let index = 0; index < e.target.value; index++) {
                bebida.push(e.target.id)
            }
        }else{
            for (let index = 0; index < e.target.value; index++) {
                bebida.push(e.target.id)
            }
        }
        // if (e.target.checked) {
        //     bebida.push(e.target.value);
        // } else {
        //         const idx = bebida.indexOf(e.target.value);
        //     if(idx > -1){
        //         bebida.splice(idx, 1);
        //     }
            
        // }
        newArray[0].bebidas = bebida
         setFormulario(newArray)
    };
    const entregaChange = (e) =>{
        setformaentrega(e.target.value)
    };
    const handleClose = () => {
        reiniciarErrorMensaje()
    };
    const handleNext = () => {
   
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
           
        
    };
    const handleBack = () => {
    
            if(activeStep === 3){
                setActiveStep(0)
                }else {
                    setActiveStep((prevActiveStep) => prevActiveStep - 1);
                }
            
        
    };
    const eliminarMenu = async id => {
        setisloading(true)
        await deleteCarrito(id , cliente)
        if(carrito.length === 1){
            setActiveStep(0)
        }
        setisloading(false)
    };
    const agregarOtroMenu = e => {
        setisloading(true)
        addCarrito(formulario[0],cliente)
        setFormulario([
            {
                platos: null,
                ingredientes : [],
                bebidas: []
            }
            ]);
        setActiveStep(0)
        setisloading(false)
    };
    //FINALIZAR ORDEN
    const finalizarOrden = async e =>{
       //FUNCION QUE AGREGA AL CARRITO,
       setisloading(true);
       if(formulario[0].platos === null){
           return 
       } 
       addCarrito(formulario[0],cliente)
       //REINICIAR EL FORMULARIO
       
       setFormulario([
        {
            platos: null,
            ingredientes : [],
            bebidas: []
        }
        ]);
        
        handleNext()
        setisloading(false)
     
    }
    //ABRIR CONFIRMACION DE PEDIDO
    const confirmarPedido = async e => {
        if(formaPago === "mercado_pago"){
            setisloading(true)
           await checkOut()
            setisloading(false)
           setOpen(true)
           
        }else {
            setOpen(true)

        }
        
    };
    //FINALIZAR PEDIDO
    const finalizarPedido = async e => {
        setisloading(true);
        await confirmarOrden(carrito, cliente, domicilio,formaentrega,formaPago,total_carrito,)
      
        setOpen(false)
        
        setTimeout(
            function(){
                setisloading(false);
               
            }
           ,
            3000
        )
        
    };
    //CANCELAR ORDEN
    const cancelOrder = async e => {
        setisloading(true)
        cancelarOrden(cliente)
        setOpen(false)
        setTimeout(
            function(){
                setisloading(false);
                setactiveComponente("cliente")
            }
           ,
            3000
        )
       
    };
        //DUPLICAR MENU
        const duplicateMenu = async menu => {
            let duplicar = {
                platos : null,
                ingredientes : [],
                bebidas : [],
            }
            if(menu.platos){
                duplicar.platos = menu.platos._id;
            }
            if(menu.ingredientes.length > 0){
                menu.ingredientes.forEach(ingrediente => {
                    duplicar.ingredientes.push(ingrediente._id)
                });
                
            }
            if(menu.bebidas.length > 0){
                menu.bebidas.forEach(bebida => {
                    duplicar.bebidas.push(bebida._id)
                });
            }
            await addCarrito(duplicar , cliente)
            }
    return ( <>
              <Backdrop className={classes.backdrop} open={isloading} onClick={handleClose}>
                <CircularProgress color="inherit" />
              </Backdrop>
              <Container maxWidth='sm'>
             
              <Snackbar open={mensaje ? true : false} autoHideDuration={3000} 
                        onClose={handleClose}
                        anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                <Alert onClose={handleClose} severity="success">
                    {mensaje}
                </Alert>
                </Snackbar>
                <Snackbar open={error} autoHideDuration={6000} 
                        onClose={handleClose}
                        anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                    <Alert onClose={handleClose} severity="error">
                        {mensaje}
                    </Alert>
                </Snackbar>
            
          
              <Stepper activeStep={activeStep} orientation="vertical" className={classes.stepper}>
                        {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                    <StepContent>
                                        <FormControl component="fieldset" className={classes.form} >
                                            {getStepContent(index)}
                                        </FormControl >
                                     <div className={classes.botonera}>
                                            <div>
                                            
                                                <Button
                                                disabled={activeStep === 0}
                                                variant='contained'
                                                onClick={handleBack}
                                                >
                                               {activeStep === 3 ? 'Olvide algo' : 'Atras'} 
                                                </Button>
                                             
                                                {activeStep === steps.length - 4 ? <div>
                                                        <Button 
                                                        onClick = {agregarOtroMenu}
                                                        variant="contained"
                                                            color="primary">
                                                                Agregar otro menu
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="secondary" 
                                                            onClick={finalizarOrden}>
                                                            Nada mas que agregar
                                                        </Button>
                                                        </div> 
                                                        : null}
                                                {activeStep <= 1 ? <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handleNext}
                                                                    disabled = {formulario[0].platos === null }
                                                                    > 
                                                                    Siguiente
                                                                    </Button> 
                                                                    : null }    
                                                {activeStep >= 3 && activeStep < 5 ?<Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handleNext}
                                                                    disabled = {formaentrega === null && activeStep === 4 ? true : null}
                                                                    > 
                                                                    Siguiente
                                                                    </Button> 
                                                                    : null
                                                                    }  
                                               {activeStep === 5 ?
                                                                    <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={confirmarPedido}
                                                                    disabled = {formaPago === null}
                                                                    > 
                                                                    Finalizar Orden
                                                                    </Button> 
                                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </StepContent>
                                </Step>
                        ))}
            </Stepper>
            <Dialog
                open={Open}
                
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirmar su pedido?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.cabecera}>
                        <Typography variant="body1" color="textprimary" >Forma de Entrega: </Typography>
                        <Typography display="block" color="secondary" className={classes.descripcion}>{formaentrega ? formaentrega : null}</Typography>
                                                {formaentrega ==="take away" ? 
                                                null : <div>
                                                    <Typography variant="body2" color="textprimary">Domicilio:</Typography>
                                                    <Typography display="block" color="secondary" className={classes.descripcion} >{domicilio.calle}</Typography>
                                                    <Typography variant="body2"color="textprimary">Barrio:</Typography>
                                                    <Typography display="block" color="secondary" className={classes.descripcion} >{domicilio.barrio}</Typography>
                                                    </div>}
                        <Typography variant="body1" >Forma de Pago:</Typography>
                        <Typography display="block" color="secondary" className={classes.descripcion} > {formaPago === "pago_en_destino" ? "Efectivo" : "Mercado Pago"}</Typography>
                        {carrito ? carrito.map(menu =>{
                            return  <Card  key= {menu._id} className = {classes.card}>
                                <CardContent>
                                  <Typography variant="h5" component="h2" className={classes.titulo}>
                                        {menu.platos.nombre}
                                </Typography>
                                <Typography  color="textSecondary">
                                    Ingredientes:
                                </Typography>
                                {menu.ingredientes.map(ingre =>{
                                    return <Typography key ={ingre._id}variant="body2" component="p"className={classes.descripcion}>
                                            { ingre.nombre }
                                            </Typography>
                                })}
                             
                                <Typography  color="textSecondary">
                                    Bebidas:
                                </Typography>
                                {menu.bebidas.map(bebida =>{
                                    return <Typography key = {bebida._id} variant="body2" component="p" className={classes.descripcion}>
                                            { bebida.nombre}
                                            </Typography>
                                })}
                                <Typography>
                                    Subtotal : $ {
                                       menu.subtotal
                                        
                                    }
                                </Typography>
                            </CardContent>
                        <CardActions>
                                <Button size="small" onClick= {e=> eliminarMenu(menu._id)}> Eliminar</Button>
                                <Button size="small" variant="contained" onClick= {e=> duplicateMenu(menu)}> Agregar otro</Button>
                    </CardActions>
                  </Card>
                
                     })
                    : <Typography>No hay elementos en el carrito</Typography>}
                         {carrito.length !== 0 ? <Typography className= {classes.precio} variant="body1">PRECIO FINAL : ${total_carrito}</Typography> : <CircularProgress className={classes.circular} color="secondary" />}
                    </DialogContentText>
                </DialogContent>
            <DialogActions>
          <Button onClick={cancelOrder} color="primary">
            Cancelar orden
          </Button>
          <Button onClick={finalizarPedido} color="primary" variant="contained" autoFocus>
            Confirmar pedido
          </Button>
        </DialogActions>
      </Dialog>
            </Container>
       </>
    )
}


 
export default GenerarPedido;